import { render, staticRenderFns } from "./text-header-title.vue?vue&type=template&id=e499c020&scoped=true"
import script from "./text-header-title.vue?vue&type=script&lang=js"
export * from "./text-header-title.vue?vue&type=script&lang=js"
import style0 from "./text-header-title.vue?vue&type=style&index=0&id=e499c020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e499c020",
  null
  
)

export default component.exports